/**
 *  Filters actions module file
**/

export const actions = {}
